"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaFileTypeToJSON = exports.MediaFileTypeFromJSONTyped = exports.MediaFileTypeFromJSON = exports.MediaFileType = void 0;
/**
 * The file type of the audio, image or video asset as defined by the 'file type' specification of the ISO base media file format standard.
 * @export
 */
exports.MediaFileType = {
    Jpeg: 'JPEG',
    Png: 'PNG',
    Mp4: 'MP4',
    Quicktime: 'QUICKTIME',
    Mp3: 'MP3',
    Ogg: 'OGG',
    Wav: 'WAV'
};
function MediaFileTypeFromJSON(json) {
    return MediaFileTypeFromJSONTyped(json, false);
}
exports.MediaFileTypeFromJSON = MediaFileTypeFromJSON;
function MediaFileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MediaFileTypeFromJSONTyped = MediaFileTypeFromJSONTyped;
function MediaFileTypeToJSON(value) {
    return value;
}
exports.MediaFileTypeToJSON = MediaFileTypeToJSON;
